// This component extends Bootstrap dropdown

import $ from 'jquery';

$(".js-select-menu a").click(function(){
	const $self = $( this );
	const label = $self.text();
	$self
		.closest( '.js-select' )
		.find( '.js-select-toggle' )
		.text( label );

	$self
		.closest( '.js-select-menu' )
		.find( 'a' )
		.removeClass( 'is-current' );

	$self
		.closest( 'a' )
		.addClass( 'is-current' );
});

